/**
 * contains the abi and contract address
*/

class MessagingContract {
    constructor() {
        this.abi = [
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "address",
				"name": "toUser",
				"type": "address"
			},
			{
				"internalType": "bytes32",
				"name": "referenceHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "messageContentHash",
				"type": "bytes32"
			}
		],
		"name": "sendPublicMessage",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "messageContentHash",
				"type": "bytes32"
			}
		],
		"name": "deleteMessage",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "fromUser",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "toUser",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "referencedHash",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "messageContentHash",
				"type": "bytes32"
			}
		],
		"name": "PublicMessageSent",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "messageContentHash",
				"type": "bytes32"
			}
		],
		"name": "PublicMessageDeleted",
		"type": "event"
	}
        ];

        this.contractAddress = '0xb407EFd2254583C8BF99c578c7b891313AC1933E';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default MessagingContract;
